module.exports = __webpack_public_path__ + "static/img/invite_job_banner_h5.7c4e385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/invite_job_banner_h5.png
// module id = 2SfH
// module chunks = 34